import { render, staticRenderFns } from "./t-app-menu-group-item.vue?vue&type=template&id=c66616e2&scoped=true&"
import script from "./t-app-menu-group-item.vue?vue&type=script&lang=js&"
export * from "./t-app-menu-group-item.vue?vue&type=script&lang=js&"
import style0 from "./t-app-menu-group-item.vue?vue&type=style&index=0&id=c66616e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66616e2",
  null
  
)

export default component.exports